var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAlertInfoIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#0273FD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1546 23.2449C14.1546 24.3289 14.9492 25 16 25C17.026 25 17.8462 24.3031 17.8462 23.2449L17.8462 13.3053C17.8462 12.247 17.026 11.5501 16 11.5501C14.9492 11.5501 14.1546 12.222 14.1546 13.3053L14.1546 23.2449ZM14 8.01407C14.0009 8.54788 14.2119 9.05957 14.5868 9.43696C14.9617 9.81435 15.4699 10.0266 16 10.0273C16.5301 10.0266 17.0383 9.81435 17.4132 9.43696C17.7881 9.05957 17.9991 8.54788 18 8.01407C17.9993 7.48011 17.7884 6.9682 17.4135 6.59064C17.0386 6.21307 16.5302 6.00066 16 6C15.4698 6.00066 14.9614 6.21307 14.5865 6.59064C14.2116 6.9682 14.0007 7.48011 14 8.01407Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertInfoIcon);
export default __webpack_public_path__ + "static/media/alert-info-icon.09ebb59d5cebb2b189049bf33c5511fb.svg";
export { ForwardRef as ReactComponent };